import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab']
  static values = { errorSelectors: { type: Array, default: ['li.error', '.inline-errors'] } }

  connect() {
    this.#openTabsWithErrors()
  }

  #openTabsWithErrors() {
    this.tabTargets.forEach((detailsEl) => {
      if (detailsEl.querySelector(this.errorSelectorsValue.join(', '))) {
        detailsEl.open = true
      }
    })
  }
}
